import * as React from "react";
import { Helmet } from "react-helmet-async";
import { Routes, Route } from "react-router-dom";
import ResetPasswordEmail from "../../components/ResetEmail";

export function EmailConfirmationPage() {
  return (
    <>
      <Helmet>
        <title>EmailConfirmationPage</title>
        <meta
          name="description"
          content="A React Boilerplate application homepage"
        />
      </Helmet>
      <div>
        <ResetPasswordEmail />
      </div>
    </>
  );
}
